import React, { useState, useEffect } from 'react';
import {
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { arrowBack, tvOutline, gridOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import QuickAccessCodeEntry from '../components/QuickAccessCodeEntry';
import { getKioskSession, clearKioskSession } from '../services/quickAccess';
import './QuickAccessPage.css';

interface DashboardAccessResult {
  dashboardId: string;
  householdId: string;
  dashboardName?: string;
  codeName?: string;
}

const QuickAccessPage: React.FC = () => {
  const history = useHistory();
  const [connectedDashboard, setConnectedDashboard] = useState<DashboardAccessResult | null>(null);

  // Check for existing kiosk session on mount
  useEffect(() => {
    const existingSession = getKioskSession();
    if (existingSession) {
      // Already have a valid session, redirect to dashboard
      history.replace(`/kiosk/${existingSession.dashboardId}`);
    }
  }, [history]);

  const handleSuccess = (result: DashboardAccessResult) => {
    setConnectedDashboard(result);

    // Navigate to the kiosk dashboard view after a brief moment
    setTimeout(() => {
      history.replace(`/kiosk/${result.dashboardId}`);
    }, 1500);
  };

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <IonPage className="quick-access-page">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={handleCancel}>
              <IonIcon icon={arrowBack} slot="icon-only" />
            </IonButton>
          </IonButtons>
          <IonTitle>Dashboard Access</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent className="quick-access-content">
        <div className="quick-access-wrapper">
          {/* Icon header */}
          <div className="quick-access-icon">
            <IonIcon icon={gridOutline} />
          </div>

          {/* Code entry component */}
          <QuickAccessCodeEntry
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />

          {/* Instructions footer */}
          <div className="quick-access-instructions">
            <h3>How it works</h3>
            <ol>
              <li>Ask an admin to generate an access code for a dashboard</li>
              <li>Enter the 6-digit code above</li>
              <li>This device will display the dashboard</li>
            </ol>
            <p className="instruction-note">
              Access codes are permanent until revoked by an admin.
            </p>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default QuickAccessPage;
